/**
 * Menu
 */

var Menu = (function($) {
  function initMenu() {
    const nav = document.querySelector(".header-nav");
    const menuItems = gsap.utils.toArray(".header-menu__item");

    if (!nav || !menuItems.length) return;

    const links = gsap.utils.toArray(".header-menu__item a");

    // Guardamos las alturas naturales antes de colapsar
    const heights = menuItems.map(
      (item) => item.getBoundingClientRect().height,
    );

    // Estado inicial
    gsap.set(nav, {
      visibility: "hidden",
    });

    gsap.set(menuItems, {
      height: 0,
      opacity: 0,
      borderBottomWidth: 0,
    });

    gsap.set(links, {
      y: 15,
      opacity: 0,
    });

    const t1 = gsap.timeline({
      paused: true,

      onStart: function() {
        document.body.classList.add("has-nav");
        $(".hamburger__text").text("Cerrar");
      },

      onReverseComplete: function() {
        document.body.classList.remove("has-nav");
        $(".hamburger__text").text("Menu");
        gsap.set(nav, { visibility: "hidden" });
      },
    });

    // Mostrar contenedor
    t1.set(nav, {
      visibility: "visible",
    });

    // Desplegar cada fila progresivamente
    menuItems.forEach((item, index) => {
      const position = index * 0.12;

      // 1. Primero se despliega el bloque
      t1.to(
        item,
        {
          height: heights[index],
          opacity: 1,
          borderBottomWidth: 1,
          duration: 0.55,
          ease: "power3.inOut",
        },
        position,
      );

      gsap.set(links, {
        y: 10,
        opacity: 1,
      });

      // 2. Después aparece el texto
      t1.to(
        links[index],
        {
          y: 0,
          opacity: 1,
          duration: 0.45,
          ease: "sine.out",
        },
        position + 0.35,
      );
    });

    // Toggle
    $(document).on("click", function(event) {
      if ($(event.target).closest(".hamburger").length) {
        if (t1.progress() === 0 || t1.reversed()) {
          t1.play();
        } else {
          t1.reverse();
        }
      } else if ($(event.target).closest(".header-menu__item a").length) {
        t1.reverse();
      }
    });
  }

  function init() {
    if (!$(".header").length) return;

    initMenu();

    $("#go-to-top").click(function(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  return {
    init: init,
  };
})(jQuery);

jQuery(document).ready(Menu.init);
